import React, { useEffect, useState } from "react";
import "./style.css";

const statsData = [
  { label: "Peças entregues", value: 5000 },
  { label: "Caminhões atendidos", value: 1200 },
  { label: "Anos de experiência", value: 2 },
  { label: "Marcas atendidas", value: 50 },
];

const Statics = () => {
  const [count, setCount] = useState(statsData.map(() => 0));

  useEffect(() => {
    const interval = setInterval(() => {
      setCount((prevCount) =>
        prevCount.map((val, i) => {
          const target = statsData[i].value;
          const increment = target > 1000 ? 50 : 1;
          if (val < target) {
            return Math.min(val + increment, target);
          }
          return val;
        })
      );
    }, 30);

    return () => clearInterval(interval);
  }, []);

  return (
    <section className="estatisticas-section">
      <div className="estatisticas-container">
        {statsData.map((stat, index) => (
          <div key={index} className="estatistica-card">
            <h3 className="estatistica-numero">
              +{count[index].toLocaleString()}
            </h3>
            <p className="estatistica-label">{stat.label}</p>
          </div>
        ))}
      </div>
    </section>
  );
};

export default Statics;
